/**
 * @generated SignedSource<<2dc03c374d120e3a0a215d9e2722bd6f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UtilizationGrantPermission = "END_ON_OPEN" | "END_RENTAL" | "UNLOCK" | "%future added value";
export type UtilizationGrantInviteAnonymousInput = {
  email: string;
  expiresAt?: any | null | undefined;
  permissions?: ReadonlyArray<UtilizationGrantPermission>;
  reservationId: string;
  returnBaseUrl?: string | null | undefined;
};
export type ShareAccessDrawerInviteMutation$variables = {
  input: UtilizationGrantInviteAnonymousInput;
};
export type ShareAccessDrawerInviteMutation$data = {
  readonly lockUtilizationGrantInviteAnonymous: {
    readonly expiresAt: any | null | undefined;
    readonly id: string;
  };
};
export type ShareAccessDrawerInviteMutation = {
  response: ShareAccessDrawerInviteMutation$data;
  variables: ShareAccessDrawerInviteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UtilizationGrant",
    "kind": "LinkedField",
    "name": "lockUtilizationGrantInviteAnonymous",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareAccessDrawerInviteMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ShareAccessDrawerInviteMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "59f7cdb194e1b4e1b0b023b2096858df",
    "id": null,
    "metadata": {},
    "name": "ShareAccessDrawerInviteMutation",
    "operationKind": "mutation",
    "text": "mutation ShareAccessDrawerInviteMutation(\n  $input: UtilizationGrantInviteAnonymousInput!\n) {\n  lockUtilizationGrantInviteAnonymous(input: $input) {\n    id\n    expiresAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "31fbf7cff5e7ab454b1c92e2bc25ff85";

export default node;
